module.exports = __webpack_public_path__ + "static/img/drag.f49ab047.svg";